import React from 'react';
import { browserHistory } from 'react-router';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import ModuleCustomizationListFilterContainer from './ModuleCustomizationListFilterContainer';
import ModuleCustomizationListContainer from './ModuleCustomizationListContainer';

const ModuleCustomizationListScene = () => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Module Customizations',
        },
      ]}
    />
    <Card
      title="Module Customizations"
      actions={
        <Button
          type="primary"
          label="New Module Customization"
          icon="plus"
          onClick={() => browserHistory.push('/module-customizations/new')}
        />
      }
    >
      <ModuleCustomizationListFilterContainer />
      <ModuleCustomizationListContainer />
    </Card>
  </div>
);

export default ModuleCustomizationListScene;
